import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import CompanyAdminRoute from './components/CompanyAdminRoute';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import CompanyAdmin from './pages/CompanyAdmin';
import UserDashboards from './pages/UserDashboards';
import DashboardView from './pages/DashboardView';

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* User Routes */}
          <Route 
            path="/dashboards" 
            element={
              <PrivateRoute>
                <UserDashboards />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/dashboard/:dashboardId" 
            element={
              <PrivateRoute>
                <DashboardView />
              </PrivateRoute>
            } 
          />
          
          {/* The customer's own administration page */}
          <Route
            path="/company"
            element={
              <CompanyAdminRoute>
                <CompanyAdmin />
              </CompanyAdminRoute>
            }
          />

          {/* Admin Routes */}
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } 
          />
          
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;
